import { GridsterItemConfig } from 'angular-gridster2';
import { DashboardItemType } from './DashboardItemType.model';
import { DashboardItemData } from './DashboardItemData.model';
import { getDefaultItemStyles } from '../utils/getDefaultItemStyles';
import { getMinimalSizeForItemType } from '../utils/getMinimalSizeForItemType';

export class DashboardItem implements GridsterItemConfig {
  // constructor(x, y, cols, rows, styles, data, type) {
  //   this.x = x;
  //   this.y = y;
  //   this.type = type;
  //   this.cols = cols;
  //   this.rows = rows;
  //   this.styles = styles;
  //   this.data = data;
  // }

  id: string = window?.crypto?.randomUUID() ?? Math.random().toString();

  // general
  x = 0;

  y = 0;

  rows = 3;

  layerIndex?: number = 1;

  cols = 6;

  // other
  minItemArea = 1;

  type: DashboardItemType = DashboardItemType.EMPTY;

  minItemRows: number = getMinimalSizeForItemType(this.type).rows;

  minItemCols: number = getMinimalSizeForItemType(this.type).cols;

  styles: DashboardItemStyles = getDefaultItemStyles();

  data: DashboardItemData = {};

  dragEnabled = true;

  resizeEnabled = true;

  //functions
}

export interface DashboardItemStyles {
  padding: boolean;
  showBackground: boolean;
  background?: string;
}
